import createApi from 'cssapi'
import halftoneLeftImage from '../../images/background/halftone-left@2x.png'
import halftoneLeftReversedImage from '../../images/background/halftone-reversed-left@2x.png'
import halftoneRightReversedImage from '../../images/background/halftone-reversed-right@2x.png'
import halftoneRightImage from '../../images/background/halftone-right@2x.png'
import ricepaperTextureImage from '../../images/background/ricepaper.png'
import ricepaperTextureImageHiDpi from '../../images/background/ricepaper@2x.png'

// -----------------------------------------------------------------------------
// Define Breakpoints
// -----------------------------------------------------------------------------

const BREAKPOINT_NAMES = Object.freeze({
  SMALL_UP: `smallUp`,
  MEDIUM_UP: `mediumUp`,
  LARGE_UP: `largeUp`,
})

const { SMALL_UP, MEDIUM_UP, LARGE_UP } = BREAKPOINT_NAMES

const breakpoints = [[SMALL_UP, 600], [MEDIUM_UP, 1000], [LARGE_UP, 1850]]

// -----------------------------------------------------------------------------
// Configure CSS API
// -----------------------------------------------------------------------------

const rhythmDefault = 22
const rhythmSmallUp = 28

const config = {
  breakpoints,
  data: {
    rhythm: rhythmDefault,
    baseline: {
      lineHeight: rhythmDefault, // Baseline height
    },
    scale: {
      '-1': 10,
      '0': 14,
      '1': 17,
      '2': 21,
      '3': 24,
      '4': 28,
      smallprint: `s:-1`,
      body: `s:0`,
      lede: `s:1`,
      secondaryTitle: `s:1`,
      contentTertiaryTitle: `s:2`,
      contentSecondaryTitle: `s:3`,
      primaryTitle: `s:4`,
      contentPrimaryTitle: `s:4`,
      giant: 120,
    },
    color: {
      // Colours
      black: `#070707`,
      offBlack: `#222`,
      white: `#F5F5F5`,
      offWhite: `#EFEFEF`,
      lightGrey: `#E4E4E4`,
      grey: `#CCC`,
      darkGrey: `#888`,
      red: `#EA421B`,
      // Aliases
      // - Default
      backgroundStart: `c:lightGrey`,
      backgroundStop: `c:white`,
      text: `c:black`,
      highlight: `c:darkGrey`,
      active: `c:darkGrey`,
      disabled: `c:grey`,
      // - Inverted
      backgroundInverted: `c:black`,
      textInverted: `c:white`,
      activeInverted: `c:darkGrey`,
      highlightInverted: `c:highlight`,
      borderColor: `c:backgroundStart`,
    },
    font: {
      default: `chevin-pro, Helvetica, sans-serif`,
      title: `f:default`,
    },
    gradient: {
      background: `linear-gradient(to bottom, c:backgroundStart, c:backgroundStop 15ru)`,
      lightFade: `linear-gradient(to left ,transparent, c:borderColor 30%, c:borderColor 70%, transparent 100%)`,
      headerFade: `linear-gradient(to right, #888 0%, #DDD 50%)`,
      pageBackgroundFade: `linear-gradient(to left, rgba(0,0,0,0.1) 0%, rgba(0,0,0,0) 100%)`,
    },
    border: {
      default: `1px solid c:lightGrey`,
    },
    image: {
      halftoneLeft: `url(${halftoneLeftImage})`,
      halftoneRight: `url(${halftoneRightImage})`,
      halftoneReversedLeft: `url(${halftoneLeftReversedImage})`,
      halftoneReversedRight: `url(${halftoneRightReversedImage})`,
      ricepaperTexture: `url(${ricepaperTextureImage})`,
      ricepaperTextureHiDpi: `url(${ricepaperTextureImageHiDpi})`,
    },
    boxShadow: {
      downwards: `0px 39px 224px -5px rgba(0, 0, 0, 0.45)`,
      upwards: `0px -39px 224px -5px rgba(0, 0, 0, 0.45)`,
    },

    // -------------------------------------------------------------------------
    // SCOPES
    // -------------------------------------------------------------------------
    scopes: [
      {
        resolve: [MEDIUM_UP, LARGE_UP],
        data: {
          rhythm: rhythmSmallUp,
          baseline: {
            lineHeight: rhythmSmallUp, // Baseline height
          },
          scale: {
            '-1': 12,
            '0': 18,
            '1': 22,
            '2': 26,
            '3': 30,
            '4': 34,
            smallprint: `s:-1`,
            body: `s:0`,
            lede: `s:1`,
            secondaryTitle: `s:1`,
            contentTertiaryTitle: `s:2`,
            contentSecondaryTitle: `s:3`,
            primaryTitle: `s:4`,
            contentPrimaryTitle: `s:4`,
            giant: 180,
          },
        },
      },
    ],
  },
}

const api = createApi(config)

// -----------------------------------------------------------------------------
// Export Theme
// -----------------------------------------------------------------------------

export default api



// WEBPACK FOOTER //
// ./src/components/styles/api.js